import React from 'react';
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  IconButton,
  Input,
} from '@mui/material';
import ButtonConsensus from 'components/ButtonConsensus';
import { colors } from 'utils/colorsSteps';
import CurrencyTextField from 'components/CurrencyTextField';
import { KeyboardDatePicker } from 'components/DatePickers';
import { toast } from 'react-toastify';
import moment from 'moment';
import { orderParcelsByInitialDate } from 'utils/parcels';
import { currencyFormat, getOnlyNumbers } from 'utils/currency';
import DeleteIcon from '@mui/icons-material/Delete';
import { INSTALLMENT_TYPES } from 'constants/agreement/installmentTypes';
import InputConsensus from 'components/InputConsensus';

const InstallmentPaidBySpecificDate = props => {
  const {
    formState,
    setFormState,
    handleChange,
    handleChangeCurrency,
    handleOpenDeleteParcelModalConfirm,
    handleParcelValueChange,
    handleParcelDateChange,
    selectedIndex,
    isServicePenalty = false,
    context,
  } = props;
  const initialDateLabel =
    context === 'SERVICE' ? 'Data do primeiro cumprimento' : 'Data do primeiro pagamento';

  const handleValueChangeAndSyncTotal = (index, event) => {
    handleParcelValueChange(index, event);
    const newTotal = isServicePenalty
      ? Number(event.target.value || 0)
      : getOnlyNumbers(event.target.value) || 0;
    setFormState(fs => ({
      ...fs,
      values: {
        ...fs.values,
        totalValue: newTotal,
      },
    }));
  };

  const handleAddParcel = () => {
    const { paymentDeadline, totalValue, initialDate } = formState.values;

    if (!isValidParcel()) {
      return;
    }

    const newParcels = [];

    const newParcel = {
      date: paymentDeadline && moment(paymentDeadline),
      initialDate: initialDate && moment(initialDate),
    };

    if (isServicePenalty) {
      newParcel.hours = totalValue;
    } else {
      newParcel.value = totalValue;
    }

    newParcels.push(newParcel);

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        parcels: newParcels,
        paymentDeadline: '',
        totalValue,
        installmentType: INSTALLMENT_TYPES[context].PAID_BY_SPECIFIC_DATE,
        initialDate: '',
      },
    }));
  };

  const isValidParcel = () => {
    const { paymentDeadline, totalValue, initialDate } = formState.values;

    let isValid = true;

    if (isServicePenalty) {
      if (!totalValue || totalValue == '0') {
        toast.warn('Insira a quantidade total de horas');
        isValid = false;
      }
    } else {
      if (!totalValue || totalValue == 0) {
        toast.warn('Insira o valor total');
        isValid = false;
      }
    }
    if (!initialDate) {
      const normalizedDate = initialDateLabel.toLowerCase();
      toast.warn(`Selecione a ${normalizedDate}`);
      isValid = false;
    }
    if (!paymentDeadline) {
      toast.warn('Selecione a data final');
      isValid = false;
    }
    if (initialDate >= paymentDeadline) {
      const normalizedDate = initialDateLabel.toLowerCase();
      toast.warn(`A data final deve ser maior que a ${normalizedDate}`);
      isValid = false;
    }

    return isValid;
  };

  return (
    <>
      {formState.values.parcels.length === 0 && (
        <>
          {isServicePenalty ? (
            <>
              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 12 }}>
                <InputConsensus
                  label="Total de horas*"
                  name="totalValue"
                  variant="standard"
                  type="number"
                  onChange={handleChange}
                  value={formState.values.totalValue || ''}
                  fullWidth
                />
              </Grid>
              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 12 }}>
                <KeyboardDatePicker
                  variant="inline"
                  name="paymentDeadline"
                  label={`${initialDateLabel}*`}
                  value={formState.values.initialDate || null}
                  onChange={newDate =>
                    setFormState(formState => ({
                      ...formState,
                      values: {
                        ...formState.values,
                        initialDate: newDate,
                      },
                    }))
                  }
                />
              </Grid>
              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 12 }}>
                <KeyboardDatePicker
                  variant="inline"
                  name="paymentDeadline"
                  label="Até a data*"
                  value={formState.values.paymentDeadline || null}
                  onChange={newDate =>
                    setFormState(formState => ({
                      ...formState,
                      values: {
                        ...formState.values,
                        paymentDeadline: newDate,
                      },
                    }))
                  }
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 12 }}>
                <CurrencyTextField
                  label="Valor total a pagar*"
                  name="totalValue"
                  onChange={handleChangeCurrency}
                  value={formState.values.totalValue / 100 || 0}
                  fullWidth
                />
              </Grid>
              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 12 }}>
                <KeyboardDatePicker
                  variant="inline"
                  name="paymentDeadline"
                  label={`${initialDateLabel}*`}
                  value={formState.values.initialDate || null}
                  onChange={newDate =>
                    setFormState(formState => ({
                      ...formState,
                      values: {
                        ...formState.values,
                        initialDate: newDate,
                      },
                    }))
                  }
                />
              </Grid>
              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 12 }}>
                <KeyboardDatePicker
                  variant="inline"
                  name="paymentDeadline"
                  label="Até a data*"
                  value={formState.values.paymentDeadline || null}
                  onChange={newDate =>
                    setFormState(formState => ({
                      ...formState,
                      values: {
                        ...formState.values,
                        paymentDeadline: newDate,
                      },
                    }))
                  }
                />
              </Grid>
            </>
          )}
        </>
      )}
      {formState.values.parcels && formState.values.parcels.length === 0 && (
        <Grid
          style={{ display: 'flex', justifyContent: 'flex-end' }}
          size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
          <ButtonConsensus
            title="Gerar Parcela"
            backgroundColor={colors.primary}
            hovercolor={colors.primary}
            onClick={() => handleAddParcel()}
            size="medium"
          />
        </Grid>
      )}
      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center">{initialDateLabel}</TableCell>
                <TableCell align="center">Data Final</TableCell>
                <TableCell align="center">
                  {isServicePenalty ? 'Total de Horas' : 'Valor Total'}
                </TableCell>
                <TableCell align="center" width={150}>
                  <Box display="flex" position="relative" justifyContent="center">
                    Ações
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderParcelsByInitialDate(formState.values.parcels).map((item, index) => (
                <TableRow key={index} hover>
                  <TableCell component="th" scope="row" align="center">
                    <KeyboardDatePicker
                      variant="inline"
                      name="initialDate"
                      value={item.initialDate || null}
                      onChange={newDate => handleParcelDateChange(index, newDate, true)}
                    />
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    <KeyboardDatePicker
                      variant="inline"
                      name="paymentDeadline"
                      value={item.date || null}
                      onChange={newDate => handleParcelDateChange(index, newDate)}
                    />
                  </TableCell>
                  {isServicePenalty ? (
                    <TableCell component="th" scope="row" align="center">
                      <InputConsensus
                        name="hours"
                        type="number"
                        onChange={e => handleValueChangeAndSyncTotal(index, e)}
                        value={item.hours || ''}
                        fullWidth
                      />
                    </TableCell>
                  ) : (
                    <TableCell component="th" scope="row" align="center">
                      <CurrencyTextField
                        name="value"
                        onChange={e => handleValueChangeAndSyncTotal(index, e)}
                        value={item.value ? item.value / 100 : 0}
                        fullWidth
                      />
                    </TableCell>
                  )}
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() => handleOpenDeleteParcelModalConfirm(item)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell align="left" colSpan={3} style={{ fontWeight: 'bold' }}>
                  {isServicePenalty ? (
                    <>Total de Horas: {formState.values.totalValue}</>
                  ) : (
                    <>Valor Total: {currencyFormat(formState.values.totalValue / 100)}</>
                  )}
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>
    </>
  );
};

export default InstallmentPaidBySpecificDate;
